/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiRateEvanmiyaGet$Any } from '../fn/rate/api-rate-evanmiya-get-any';
import { ApiRateEvanmiyaGet$Any$Params } from '../fn/rate/api-rate-evanmiya-get-any';
import { apiRateEvanmiyaGet$Json } from '../fn/rate/api-rate-evanmiya-get-json';
import { ApiRateEvanmiyaGet$Json$Params } from '../fn/rate/api-rate-evanmiya-get-json';
import { apiRateEvanmiyaGet$JsonOdataMetadataFull } from '../fn/rate/api-rate-evanmiya-get-json-odata-metadata-full';
import { ApiRateEvanmiyaGet$JsonOdataMetadataFull$Params } from '../fn/rate/api-rate-evanmiya-get-json-odata-metadata-full';
import { apiRateEvanmiyaGet$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/rate/api-rate-evanmiya-get-json-odata-metadata-full-odata-streaming-false';
import { ApiRateEvanmiyaGet$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/rate/api-rate-evanmiya-get-json-odata-metadata-full-odata-streaming-false';
import { apiRateEvanmiyaGet$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/rate/api-rate-evanmiya-get-json-odata-metadata-full-odata-streaming-true';
import { ApiRateEvanmiyaGet$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/rate/api-rate-evanmiya-get-json-odata-metadata-full-odata-streaming-true';
import { apiRateEvanmiyaGet$JsonOdataMetadataMinimal } from '../fn/rate/api-rate-evanmiya-get-json-odata-metadata-minimal';
import { ApiRateEvanmiyaGet$JsonOdataMetadataMinimal$Params } from '../fn/rate/api-rate-evanmiya-get-json-odata-metadata-minimal';
import { apiRateEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/rate/api-rate-evanmiya-get-json-odata-metadata-minimal-odata-streaming-false';
import { ApiRateEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/rate/api-rate-evanmiya-get-json-odata-metadata-minimal-odata-streaming-false';
import { apiRateEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/rate/api-rate-evanmiya-get-json-odata-metadata-minimal-odata-streaming-true';
import { ApiRateEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/rate/api-rate-evanmiya-get-json-odata-metadata-minimal-odata-streaming-true';
import { apiRateEvanmiyaGet$JsonOdataMetadataNone } from '../fn/rate/api-rate-evanmiya-get-json-odata-metadata-none';
import { ApiRateEvanmiyaGet$JsonOdataMetadataNone$Params } from '../fn/rate/api-rate-evanmiya-get-json-odata-metadata-none';
import { apiRateEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/rate/api-rate-evanmiya-get-json-odata-metadata-none-odata-streaming-false';
import { ApiRateEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/rate/api-rate-evanmiya-get-json-odata-metadata-none-odata-streaming-false';
import { apiRateEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/rate/api-rate-evanmiya-get-json-odata-metadata-none-odata-streaming-true';
import { ApiRateEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/rate/api-rate-evanmiya-get-json-odata-metadata-none-odata-streaming-true';
import { apiRateEvanmiyaGet$JsonOdataStreamingFalse } from '../fn/rate/api-rate-evanmiya-get-json-odata-streaming-false';
import { ApiRateEvanmiyaGet$JsonOdataStreamingFalse$Params } from '../fn/rate/api-rate-evanmiya-get-json-odata-streaming-false';
import { apiRateEvanmiyaGet$JsonOdataStreamingTrue } from '../fn/rate/api-rate-evanmiya-get-json-odata-streaming-true';
import { ApiRateEvanmiyaGet$JsonOdataStreamingTrue$Params } from '../fn/rate/api-rate-evanmiya-get-json-odata-streaming-true';
import { apiRateEvanmiyaGet$Plain } from '../fn/rate/api-rate-evanmiya-get-plain';
import { ApiRateEvanmiyaGet$Plain$Params } from '../fn/rate/api-rate-evanmiya-get-plain';
import { apiRateEvanmiyaGet$Xml } from '../fn/rate/api-rate-evanmiya-get-xml';
import { ApiRateEvanmiyaGet$Xml$Params } from '../fn/rate/api-rate-evanmiya-get-xml';
import { apiRateRealgmGet$Any } from '../fn/rate/api-rate-realgm-get-any';
import { ApiRateRealgmGet$Any$Params } from '../fn/rate/api-rate-realgm-get-any';
import { apiRateRealgmGet$Json } from '../fn/rate/api-rate-realgm-get-json';
import { ApiRateRealgmGet$Json$Params } from '../fn/rate/api-rate-realgm-get-json';
import { apiRateRealgmGet$JsonOdataMetadataFull } from '../fn/rate/api-rate-realgm-get-json-odata-metadata-full';
import { ApiRateRealgmGet$JsonOdataMetadataFull$Params } from '../fn/rate/api-rate-realgm-get-json-odata-metadata-full';
import { apiRateRealgmGet$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/rate/api-rate-realgm-get-json-odata-metadata-full-odata-streaming-false';
import { ApiRateRealgmGet$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/rate/api-rate-realgm-get-json-odata-metadata-full-odata-streaming-false';
import { apiRateRealgmGet$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/rate/api-rate-realgm-get-json-odata-metadata-full-odata-streaming-true';
import { ApiRateRealgmGet$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/rate/api-rate-realgm-get-json-odata-metadata-full-odata-streaming-true';
import { apiRateRealgmGet$JsonOdataMetadataMinimal } from '../fn/rate/api-rate-realgm-get-json-odata-metadata-minimal';
import { ApiRateRealgmGet$JsonOdataMetadataMinimal$Params } from '../fn/rate/api-rate-realgm-get-json-odata-metadata-minimal';
import { apiRateRealgmGet$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/rate/api-rate-realgm-get-json-odata-metadata-minimal-odata-streaming-false';
import { ApiRateRealgmGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/rate/api-rate-realgm-get-json-odata-metadata-minimal-odata-streaming-false';
import { apiRateRealgmGet$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/rate/api-rate-realgm-get-json-odata-metadata-minimal-odata-streaming-true';
import { ApiRateRealgmGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/rate/api-rate-realgm-get-json-odata-metadata-minimal-odata-streaming-true';
import { apiRateRealgmGet$JsonOdataMetadataNone } from '../fn/rate/api-rate-realgm-get-json-odata-metadata-none';
import { ApiRateRealgmGet$JsonOdataMetadataNone$Params } from '../fn/rate/api-rate-realgm-get-json-odata-metadata-none';
import { apiRateRealgmGet$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/rate/api-rate-realgm-get-json-odata-metadata-none-odata-streaming-false';
import { ApiRateRealgmGet$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/rate/api-rate-realgm-get-json-odata-metadata-none-odata-streaming-false';
import { apiRateRealgmGet$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/rate/api-rate-realgm-get-json-odata-metadata-none-odata-streaming-true';
import { ApiRateRealgmGet$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/rate/api-rate-realgm-get-json-odata-metadata-none-odata-streaming-true';
import { apiRateRealgmGet$JsonOdataStreamingFalse } from '../fn/rate/api-rate-realgm-get-json-odata-streaming-false';
import { ApiRateRealgmGet$JsonOdataStreamingFalse$Params } from '../fn/rate/api-rate-realgm-get-json-odata-streaming-false';
import { apiRateRealgmGet$JsonOdataStreamingTrue } from '../fn/rate/api-rate-realgm-get-json-odata-streaming-true';
import { ApiRateRealgmGet$JsonOdataStreamingTrue$Params } from '../fn/rate/api-rate-realgm-get-json-odata-streaming-true';
import { apiRateRealgmGet$Plain } from '../fn/rate/api-rate-realgm-get-plain';
import { ApiRateRealgmGet$Plain$Params } from '../fn/rate/api-rate-realgm-get-plain';
import { apiRateRealgmGet$Xml } from '../fn/rate/api-rate-realgm-get-xml';
import { ApiRateRealgmGet$Xml$Params } from '../fn/rate/api-rate-realgm-get-xml';
import { apiRateStatheadGet$Any } from '../fn/rate/api-rate-stathead-get-any';
import { ApiRateStatheadGet$Any$Params } from '../fn/rate/api-rate-stathead-get-any';
import { apiRateStatheadGet$Json } from '../fn/rate/api-rate-stathead-get-json';
import { ApiRateStatheadGet$Json$Params } from '../fn/rate/api-rate-stathead-get-json';
import { apiRateStatheadGet$JsonOdataMetadataFull } from '../fn/rate/api-rate-stathead-get-json-odata-metadata-full';
import { ApiRateStatheadGet$JsonOdataMetadataFull$Params } from '../fn/rate/api-rate-stathead-get-json-odata-metadata-full';
import { apiRateStatheadGet$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/rate/api-rate-stathead-get-json-odata-metadata-full-odata-streaming-false';
import { ApiRateStatheadGet$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/rate/api-rate-stathead-get-json-odata-metadata-full-odata-streaming-false';
import { apiRateStatheadGet$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/rate/api-rate-stathead-get-json-odata-metadata-full-odata-streaming-true';
import { ApiRateStatheadGet$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/rate/api-rate-stathead-get-json-odata-metadata-full-odata-streaming-true';
import { apiRateStatheadGet$JsonOdataMetadataMinimal } from '../fn/rate/api-rate-stathead-get-json-odata-metadata-minimal';
import { ApiRateStatheadGet$JsonOdataMetadataMinimal$Params } from '../fn/rate/api-rate-stathead-get-json-odata-metadata-minimal';
import { apiRateStatheadGet$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/rate/api-rate-stathead-get-json-odata-metadata-minimal-odata-streaming-false';
import { ApiRateStatheadGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/rate/api-rate-stathead-get-json-odata-metadata-minimal-odata-streaming-false';
import { apiRateStatheadGet$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/rate/api-rate-stathead-get-json-odata-metadata-minimal-odata-streaming-true';
import { ApiRateStatheadGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/rate/api-rate-stathead-get-json-odata-metadata-minimal-odata-streaming-true';
import { apiRateStatheadGet$JsonOdataMetadataNone } from '../fn/rate/api-rate-stathead-get-json-odata-metadata-none';
import { ApiRateStatheadGet$JsonOdataMetadataNone$Params } from '../fn/rate/api-rate-stathead-get-json-odata-metadata-none';
import { apiRateStatheadGet$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/rate/api-rate-stathead-get-json-odata-metadata-none-odata-streaming-false';
import { ApiRateStatheadGet$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/rate/api-rate-stathead-get-json-odata-metadata-none-odata-streaming-false';
import { apiRateStatheadGet$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/rate/api-rate-stathead-get-json-odata-metadata-none-odata-streaming-true';
import { ApiRateStatheadGet$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/rate/api-rate-stathead-get-json-odata-metadata-none-odata-streaming-true';
import { apiRateStatheadGet$JsonOdataStreamingFalse } from '../fn/rate/api-rate-stathead-get-json-odata-streaming-false';
import { ApiRateStatheadGet$JsonOdataStreamingFalse$Params } from '../fn/rate/api-rate-stathead-get-json-odata-streaming-false';
import { apiRateStatheadGet$JsonOdataStreamingTrue } from '../fn/rate/api-rate-stathead-get-json-odata-streaming-true';
import { ApiRateStatheadGet$JsonOdataStreamingTrue$Params } from '../fn/rate/api-rate-stathead-get-json-odata-streaming-true';
import { apiRateStatheadGet$Plain } from '../fn/rate/api-rate-stathead-get-plain';
import { ApiRateStatheadGet$Plain$Params } from '../fn/rate/api-rate-stathead-get-plain';
import { apiRateStatheadGet$Xml } from '../fn/rate/api-rate-stathead-get-xml';
import { ApiRateStatheadGet$Xml$Params } from '../fn/rate/api-rate-stathead-get-xml';
import { StringListResult } from '../models/string-list-result';

@Injectable({ providedIn: 'root' })
export class RateService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiRateEvanmiyaGet()` */
  static readonly ApiRateEvanmiyaGetPath = '/api/rate/evanmiya';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiRateEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiRateEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiRateEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiRateEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateEvanmiyaGet$JsonOdataMetadataMinimal()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateEvanmiyaGet$JsonOdataMetadataMinimal$Response(params?: ApiRateEvanmiyaGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateEvanmiyaGet$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateEvanmiyaGet$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateEvanmiyaGet$JsonOdataMetadataMinimal(params?: ApiRateEvanmiyaGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateEvanmiyaGet$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateEvanmiyaGet$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateEvanmiyaGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiRateEvanmiyaGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateEvanmiyaGet$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateEvanmiyaGet$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateEvanmiyaGet$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiRateEvanmiyaGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateEvanmiyaGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateEvanmiyaGet$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateEvanmiyaGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiRateEvanmiyaGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateEvanmiyaGet$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateEvanmiyaGet$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateEvanmiyaGet$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiRateEvanmiyaGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateEvanmiyaGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateEvanmiyaGet$JsonOdataMetadataFull()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateEvanmiyaGet$JsonOdataMetadataFull$Response(params?: ApiRateEvanmiyaGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateEvanmiyaGet$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateEvanmiyaGet$JsonOdataMetadataFull$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateEvanmiyaGet$JsonOdataMetadataFull(params?: ApiRateEvanmiyaGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateEvanmiyaGet$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiRateEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiRateEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiRateEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiRateEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateEvanmiyaGet$JsonOdataMetadataNone()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateEvanmiyaGet$JsonOdataMetadataNone$Response(params?: ApiRateEvanmiyaGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateEvanmiyaGet$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateEvanmiyaGet$JsonOdataMetadataNone$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateEvanmiyaGet$JsonOdataMetadataNone(params?: ApiRateEvanmiyaGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateEvanmiyaGet$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateEvanmiyaGet$JsonOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateEvanmiyaGet$JsonOdataStreamingTrue$Response(params?: ApiRateEvanmiyaGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateEvanmiyaGet$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateEvanmiyaGet$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateEvanmiyaGet$JsonOdataStreamingTrue(params?: ApiRateEvanmiyaGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateEvanmiyaGet$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateEvanmiyaGet$JsonOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateEvanmiyaGet$JsonOdataStreamingFalse$Response(params?: ApiRateEvanmiyaGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateEvanmiyaGet$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateEvanmiyaGet$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateEvanmiyaGet$JsonOdataStreamingFalse(params?: ApiRateEvanmiyaGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateEvanmiyaGet$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateEvanmiyaGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateEvanmiyaGet$Json$Response(params?: ApiRateEvanmiyaGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateEvanmiyaGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateEvanmiyaGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateEvanmiyaGet$Json(params?: ApiRateEvanmiyaGet$Json$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateEvanmiyaGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateEvanmiyaGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateEvanmiyaGet$Xml$Response(params?: ApiRateEvanmiyaGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateEvanmiyaGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateEvanmiyaGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateEvanmiyaGet$Xml(params?: ApiRateEvanmiyaGet$Xml$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateEvanmiyaGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateEvanmiyaGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateEvanmiyaGet$Plain$Response(params?: ApiRateEvanmiyaGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateEvanmiyaGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateEvanmiyaGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateEvanmiyaGet$Plain(params?: ApiRateEvanmiyaGet$Plain$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateEvanmiyaGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateEvanmiyaGet$Any()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateEvanmiyaGet$Any$Response(params?: ApiRateEvanmiyaGet$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateEvanmiyaGet$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateEvanmiyaGet$Any$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateEvanmiyaGet$Any(params?: ApiRateEvanmiyaGet$Any$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateEvanmiyaGet$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /** Path part for operation `apiRateRealgmGet()` */
  static readonly ApiRateRealgmGetPath = '/api/rate/realgm';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateRealgmGet$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateRealgmGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiRateRealgmGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateRealgmGet$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateRealgmGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateRealgmGet$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiRateRealgmGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateRealgmGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateRealgmGet$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateRealgmGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiRateRealgmGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateRealgmGet$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateRealgmGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateRealgmGet$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiRateRealgmGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateRealgmGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateRealgmGet$JsonOdataMetadataMinimal()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateRealgmGet$JsonOdataMetadataMinimal$Response(params?: ApiRateRealgmGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateRealgmGet$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateRealgmGet$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateRealgmGet$JsonOdataMetadataMinimal(params?: ApiRateRealgmGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateRealgmGet$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateRealgmGet$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateRealgmGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiRateRealgmGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateRealgmGet$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateRealgmGet$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateRealgmGet$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiRateRealgmGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateRealgmGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateRealgmGet$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateRealgmGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiRateRealgmGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateRealgmGet$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateRealgmGet$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateRealgmGet$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiRateRealgmGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateRealgmGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateRealgmGet$JsonOdataMetadataFull()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateRealgmGet$JsonOdataMetadataFull$Response(params?: ApiRateRealgmGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateRealgmGet$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateRealgmGet$JsonOdataMetadataFull$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateRealgmGet$JsonOdataMetadataFull(params?: ApiRateRealgmGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateRealgmGet$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateRealgmGet$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateRealgmGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiRateRealgmGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateRealgmGet$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateRealgmGet$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateRealgmGet$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiRateRealgmGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateRealgmGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateRealgmGet$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateRealgmGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiRateRealgmGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateRealgmGet$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateRealgmGet$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateRealgmGet$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiRateRealgmGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateRealgmGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateRealgmGet$JsonOdataMetadataNone()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateRealgmGet$JsonOdataMetadataNone$Response(params?: ApiRateRealgmGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateRealgmGet$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateRealgmGet$JsonOdataMetadataNone$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateRealgmGet$JsonOdataMetadataNone(params?: ApiRateRealgmGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateRealgmGet$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateRealgmGet$JsonOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateRealgmGet$JsonOdataStreamingTrue$Response(params?: ApiRateRealgmGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateRealgmGet$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateRealgmGet$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateRealgmGet$JsonOdataStreamingTrue(params?: ApiRateRealgmGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateRealgmGet$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateRealgmGet$JsonOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateRealgmGet$JsonOdataStreamingFalse$Response(params?: ApiRateRealgmGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateRealgmGet$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateRealgmGet$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateRealgmGet$JsonOdataStreamingFalse(params?: ApiRateRealgmGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateRealgmGet$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateRealgmGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateRealgmGet$Json$Response(params?: ApiRateRealgmGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateRealgmGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateRealgmGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateRealgmGet$Json(params?: ApiRateRealgmGet$Json$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateRealgmGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateRealgmGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateRealgmGet$Xml$Response(params?: ApiRateRealgmGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateRealgmGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateRealgmGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateRealgmGet$Xml(params?: ApiRateRealgmGet$Xml$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateRealgmGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateRealgmGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateRealgmGet$Plain$Response(params?: ApiRateRealgmGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateRealgmGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateRealgmGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateRealgmGet$Plain(params?: ApiRateRealgmGet$Plain$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateRealgmGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateRealgmGet$Any()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateRealgmGet$Any$Response(params?: ApiRateRealgmGet$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateRealgmGet$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateRealgmGet$Any$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateRealgmGet$Any(params?: ApiRateRealgmGet$Any$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateRealgmGet$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /** Path part for operation `apiRateStatheadGet()` */
  static readonly ApiRateStatheadGetPath = '/api/rate/stathead';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateStatheadGet$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateStatheadGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiRateStatheadGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateStatheadGet$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateStatheadGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateStatheadGet$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiRateStatheadGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateStatheadGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateStatheadGet$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateStatheadGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiRateStatheadGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateStatheadGet$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateStatheadGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateStatheadGet$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiRateStatheadGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateStatheadGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateStatheadGet$JsonOdataMetadataMinimal()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateStatheadGet$JsonOdataMetadataMinimal$Response(params?: ApiRateStatheadGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateStatheadGet$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateStatheadGet$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateStatheadGet$JsonOdataMetadataMinimal(params?: ApiRateStatheadGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateStatheadGet$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateStatheadGet$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateStatheadGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiRateStatheadGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateStatheadGet$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateStatheadGet$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateStatheadGet$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiRateStatheadGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateStatheadGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateStatheadGet$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateStatheadGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiRateStatheadGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateStatheadGet$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateStatheadGet$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateStatheadGet$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiRateStatheadGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateStatheadGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateStatheadGet$JsonOdataMetadataFull()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateStatheadGet$JsonOdataMetadataFull$Response(params?: ApiRateStatheadGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateStatheadGet$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateStatheadGet$JsonOdataMetadataFull$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateStatheadGet$JsonOdataMetadataFull(params?: ApiRateStatheadGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateStatheadGet$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateStatheadGet$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateStatheadGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiRateStatheadGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateStatheadGet$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateStatheadGet$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateStatheadGet$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiRateStatheadGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateStatheadGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateStatheadGet$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateStatheadGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiRateStatheadGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateStatheadGet$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateStatheadGet$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateStatheadGet$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiRateStatheadGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateStatheadGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateStatheadGet$JsonOdataMetadataNone()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateStatheadGet$JsonOdataMetadataNone$Response(params?: ApiRateStatheadGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateStatheadGet$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateStatheadGet$JsonOdataMetadataNone$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateStatheadGet$JsonOdataMetadataNone(params?: ApiRateStatheadGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateStatheadGet$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateStatheadGet$JsonOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateStatheadGet$JsonOdataStreamingTrue$Response(params?: ApiRateStatheadGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateStatheadGet$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateStatheadGet$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateStatheadGet$JsonOdataStreamingTrue(params?: ApiRateStatheadGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateStatheadGet$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateStatheadGet$JsonOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateStatheadGet$JsonOdataStreamingFalse$Response(params?: ApiRateStatheadGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateStatheadGet$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateStatheadGet$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateStatheadGet$JsonOdataStreamingFalse(params?: ApiRateStatheadGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateStatheadGet$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateStatheadGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateStatheadGet$Json$Response(params?: ApiRateStatheadGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateStatheadGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateStatheadGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateStatheadGet$Json(params?: ApiRateStatheadGet$Json$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateStatheadGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateStatheadGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateStatheadGet$Xml$Response(params?: ApiRateStatheadGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateStatheadGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateStatheadGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateStatheadGet$Xml(params?: ApiRateStatheadGet$Xml$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateStatheadGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateStatheadGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateStatheadGet$Plain$Response(params?: ApiRateStatheadGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateStatheadGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateStatheadGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateStatheadGet$Plain(params?: ApiRateStatheadGet$Plain$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateStatheadGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRateStatheadGet$Any()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateStatheadGet$Any$Response(params?: ApiRateStatheadGet$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiRateStatheadGet$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRateStatheadGet$Any$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRateStatheadGet$Any(params?: ApiRateStatheadGet$Any$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiRateStatheadGet$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

}
